import { render, staticRenderFns } from "./QnASessions.vue?vue&type=template&id=39b234e0&"
import script from "./QnASessions.vue?vue&type=script&lang=js&"
export * from "./QnASessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports